import gsap from 'gsap';

import { DrawerBase } from '../../../core/abstraction/DrawerBase';
import { gameMobileConfig } from '../../../core/configs';
import { popupHelper } from '../../../services/helperService/PopupHelper';
import { mobileBackgroundRssNames } from '../../../core/mobileResourceNames';
import {
  buyBonusRssNames,
  congratulationsBonusPopupRes,
  congratulationsCoinRssNames
} from '../../../core/gameConstants';
import { getTranslation, translationKeys } from '../../../core/translation/translation';
import { FONT_BALOO_NAME, GAME_SCENE } from '../../../core/constats';
import { GAME_SCENE_STATE, SPIN_AMOUNT, SPIN_AMOUNT_ACTIVE } from '../../../stateManagment/gameState';
import { amountFormatter } from '../../../core/helpers/amountFormatter';
import { partnerService } from '../../../services/helperService/PartnerService';
import { delay } from '../../../core/helpers/delay';
import {gameDrawer} from "../../../game/GameDrawer";

const getAmount = val => `${getTranslation(translationKeys.yourBet)} ${amountFormatter.format(val)} ${partnerService.displayCurrency}`;

const getFontSize = val => {
  if (val.length <= 15) {
    return 50;
  } else if(val.length <= 20) {
    return 45;
  } else if (val.length > 20 && val.length < 30) {
    return 40;
  } else {
    return 35;
  }
};

export class BaseBonusCongratulationsPopup extends DrawerBase {
  translations
  execute({ root }) {
    root.children = [];
  }

  async onLoad() {
    return this.loadResource();
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(congratulationsBonusPopupRes, this.createLoader());
      this.resources = res;
    }
    return this.resources;
  }

  getPopup({
             sizes: {
               width = gameMobileConfig.width,
               parentWidth = gameMobileConfig.config.width,
               parentHeight = gameMobileConfig.config.height,
               percent = 20,
               scale = 1,
             } = {},
           } = {}) {
    /** create containers */
    const container = this.createContainer('BuyBonusMobilePopup');
    const popupContainer = this.createContainer('popupContainer');
    const popupBuyBonus = this.createSprite(this.resources[buyBonusRssNames.popupBuyBonus]);
    popupBuyBonus.scale.set(width / popupBuyBonus.width);
    popupBuyBonus.anchor.set(.5, 1);
    const popupPositionY = parentHeight / 2 + popupBuyBonus.height * percent / 100;
    container.visible = popupHelper.congratulationsBonusPopupState;
    this.setPosition(popupBuyBonus, { x: parentWidth / 2, y: popupPositionY });
    const animation = this.createSpine(this.resources[congratulationsCoinRssNames.congratulationsCoin]);
    animation.state.setAnimation(0, 'animation', true);
    this.setPosition(animation, { x: parentWidth / 2, y: popupPositionY + 100 * scale });
    animation.scale.set(width / animation.width * 1.2);

    /** config black rect*/
    const blackRect = this.createGraphics()
      .beginFill(0x000000)
      .drawRect(
        0,
        0,
        parentWidth,
        parentHeight,
      )
      .endFill();
    blackRect.alpha = .9;
    blackRect.interactive = true;
    blackRect.buttonMode = false;

    blackRect.on('pointerdown', (event) => {
      event.stopPropagation();
      popupHelper.setCongratulationsBonusPopupState(false);
      delay(() => {
        GAME_SCENE_STATE.next(GAME_SCENE.PRE_BONUS);
      }, 1000)
    });


    /** setup top shadow */
    const shadow = this.createSprite(this.resources[mobileBackgroundRssNames.shadow]);
    shadow.width = parentWidth;
    shadow.rotation = Math.PI;
    shadow.anchor.set(.5);
    this.setPosition(shadow, { x: parentWidth / 2, y: shadow.height / 2 });

    /** setup open and close state */
    this.addSubscriber(popupHelper.subscribeCongratulationsBonusPopup(isOpen => {
      if (isOpen) {
        container.visible = isOpen;
        this.setPosition(popupContainer, { y: -900 });
        gsap.to(blackRect, { duration: 1.5, ease: 'power1.out', alpha: .7 });
        gsap.to(shadow, { duration: 1.5, ease: 'power1.out', alpha: .7 });
        gsap.to(popupContainer, { duration: 1.5, ease: 'elastic.out(.2, .1)', y: 0 });
      } else {
        gsap.to(blackRect, { duration: .5, ease: 'power1.in', alpha: 0 });
        gsap.to(shadow, { duration: .5, ease: 'power1.in', alpha: 0 });
        gsap.to(popupContainer, {
          duration: .5, ease: 'power1.in', y: -800, onComplete: () => {
            container.visible = isOpen;
          },
        });
      }
    }, true));


    const textsContainer = this.createContainer('textsContainer');
    this.setPosition(textsContainer, { x: parentWidth / 2, y: popupPositionY - 250 * scale });

    const title = new this.PIXI.Text(`${getTranslation(translationKeys.CONGRATULATIONS)}!`, {
      fontSize: 40,
      fill: 0xf7e0b4,
      fontFamily: FONT_BALOO_NAME,
      align: 'center',
    });
    title.scale.set(scale);
    title.anchor.set(.5);
    const bonusGameIsActivatedText = new this.PIXI.Text(`${getTranslation(translationKeys.bonusGameIsActivated)}!`, {
      fontSize: 45,
      fill: 0xf7e0b4,
      fontFamily: FONT_BALOO_NAME,
      align: 'center',
    });
    bonusGameIsActivatedText.scale.set(scale);
    bonusGameIsActivatedText.anchor.set(.5);

    const goodLuckText = new this.PIXI.Text(`${getTranslation(translationKeys.GOOD_LUCK)}`, {
      fontSize: 40,
      fill: 0xf7e0b4,
      fontFamily: FONT_BALOO_NAME,
      align: 'center',
    });
    goodLuckText.scale.set(scale);
    goodLuckText.anchor.set(.5);

    const yourBetText = new this.PIXI.Text(`${getTranslation(translationKeys.yourBet)}`, {
      fontSize: 40,
      fill: 0xf7e0b4,
      fontFamily: FONT_BALOO_NAME,
      align: 'center',
    });
    yourBetText.scale.set(scale);
    yourBetText.anchor.set(.5);

    this.setPosition(title, { y: -100 * scale });
    this.setPosition(bonusGameIsActivatedText, { y: -40 * scale });
    this.setPosition(yourBetText, { y: 25 * scale });
    this.setPosition(goodLuckText, { y: 90 * scale });

    this.addSubscriber(SPIN_AMOUNT.subscribe(list => {
      const value = getAmount(list[SPIN_AMOUNT_ACTIVE.getValue()]);
      yourBetText.text = value;
      yourBetText.style.fontSize = getFontSize(value);
    }, true));
    this.addSubscriber(SPIN_AMOUNT_ACTIVE.subscribe(index => {
      const value = getAmount(SPIN_AMOUNT.getValue()[index]);
      yourBetText.text = value;
      yourBetText.style.fontSize = getFontSize(value);
    }, true));

    textsContainer.addChild(
      title,
      bonusGameIsActivatedText,
      yourBetText,
      goodLuckText,
    );

    popupContainer.addChild(
      popupBuyBonus,
      animation,
      textsContainer,
    );

    container.addChild(
      blackRect,
      popupContainer,
      shadow,
    );
    return container;
  }

}